"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInput_1 = require("../genericInput/GenericInput");
var PhoneWithPrefixInput = function (_a) {
    var formData = _a.formData;
    var label = formData.label, required = formData.required, id = formData.id, onChange = formData.onChange, value = formData.value, rawErrors = formData.rawErrors, inputLabel = formData.options.inputLabel;
    var currentError = react_1.useMemo(function () { var _a; return ((_a = rawErrors) === null || _a === void 0 ? void 0 : _a.length) > 0 && rawErrors[0]; }, [rawErrors]);
    var handleChange = react_1.useCallback(function (e) {
        onChange(e.target.value);
    }, [value]);
    return (<GenericInput_1.default label={label} required={required} id={id} value={value} currentError={currentError} onChange={handleChange} inputLabel={inputLabel} phoneWithPrefix={true}/>);
};
exports.default = PhoneWithPrefixInput;
